<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-right">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">Country</span>
        </h5>
      </CCol>
      <div style="clear:both"></div>
      <br />
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
          <div class="m-4">
            <CRow>
              <img src="../assets/img/Malaysia.png" style="width: 20px; height: 15px;" />
              <label class="custom-font-setting ml-2"> Malaysia </label> <br />
              <div class="float-right">
                <input type="radio" style="position: absolute; right: 30px;" />
              </div> 
            </CRow>

            <hr />
              
            <CRow>
              <img src="../assets/img/Indonesia.png" style="width: 20px; height: 15px;" />
              <label class="custom-font-setting ml-2"> Indonesia </label> <br />
              <div class="float-right">
                <input type="radio" style="position: absolute; right: 30px;" />
              </div> 
            </CRow>

            <hr />
            
            <CRow>
              <img src="../assets/img/Malaysia.png" style="width: 20px; height: 15px;" />
              <label class="custom-font-setting ml-2"> English (US) </label> <br />
              <div class="float-right">
                <input type="radio" style="position: absolute; right: 30px;" />
              </div> 
            </CRow>

            <br /><br />
          </div>
          
          <br /><br /> <br /><br /> <br /><br />
        </div>
      
              
      
      
      
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        //   GoToEdit() {
        //     this.$router.push("/EditProfile");
        //   },
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }
  </style>